// extracted by mini-css-extract-plugin
export default {"logogrid":"LogoGrid_logogrid__YrHGo","container":"LogoGrid_container__eLN31","heading":"LogoGrid_heading__+U-N6","image":"LogoGrid_image__2u7SV"};